var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 16,
    viewBox: "0 0 69 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.9689 0.148438C43.3156 0.148438 39.8267 3.65955 39.8267 7.98992V8.03288C39.8267 12.3633 43.2726 15.8299 47.9259 15.8299C52.5793 15.8299 56.0681 12.3188 56.0681 7.98992V7.94696C56.0667 3.61659 52.6207 0.148438 47.9689 0.148438ZM51.803 8.0314C51.803 10.2077 50.2741 12.0595 47.9689 12.0595C45.6859 12.0595 44.1126 10.1647 44.1126 7.98844V7.94548C44.1126 5.76918 45.6415 3.91733 47.9259 3.91733C50.2311 3.91733 51.803 5.81214 51.803 7.98844V8.0314ZM20.594 5.94255L17.4918 0.449219H12.7318L18.4607 9.88478L15.194 15.5277H19.2458L27.6621 0.449219H23.7169L20.594 5.94255ZM29.0917 0.449219H33.2695V11.8655H39.4843L37.4384 15.5277H29.0917V0.449219ZM56.4563 0.449219V4.10107H59.5304V15.4848H63.6978V4.10107H66.5778L68.6178 0.449219H56.4563ZM0 0.449219H6.46222C10.2756 0.449219 12.7304 2.40922 12.7304 5.74848V5.79144C12.7304 9.34551 9.99555 11.2196 6.24741 11.2196H4.17926V15.5277H0V7.94552H4.17926H5.29185H6.16C7.64592 7.94552 8.55111 7.1707 8.55111 5.98551V5.94255C8.55111 4.64922 7.64741 3.96033 6.13926 3.96033H5.29185H4.17926H0V0.449219Z",
    fill: "#1DBADF"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.16d9588d.svg";
export { ForwardRef as ReactComponent };